import { Session } from '../../../../curriculum';
import { AdminSection, Segment } from '../../../../curriculum/models/timeline';

type SessionTimelineSegment = {
  activity?: string;
  group: string;
  name: string;
};

type SegmentEditedEventPayload = {
  session: { sessionId: string; name: string };
  segment: SessionTimelineSegment;
  section: { type: string };
};

export function formatSectionEditedEvent(
  session: Session,
  segment: Segment,
  section: AdminSection
): SegmentEditedEventPayload {
  const { sessionId, name: sessionName } = session;
  const { activity, group, name: segmentName } = segment;
  const { type: sectionType } = section;
  return {
    session: { sessionId, name: sessionName },
    segment: { activity, group, name: segmentName },
    section: { type: sectionType },
  };
}
